var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaersk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000096745422287023299710000008425786254455116467_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4_00000162346772795507691350000004693386626181300379_",
    className: "st0",
    points: "43.2,29.5 43.2,20.5 45.6,20.5  48.7,27.2 51.7,20.5 54,20.5 54,29.5 52,29.5 52,24.3 49.7,29.5 47.6,29.5 45.3,24.3 45.3,29.5 43.2,29.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5_00000011734334980271652690000013525433744876694460_",
    className: "st0",
    d: "M62,26l-1.7-3.8L58.8,26H62z M57.3,29.5H55 l4-9.1h2.9l4.1,9.1h-2.3l-0.8-1.8H58L57.3,29.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6_00000099634473510213072060000002054680813339402915_",
    className: "st0",
    points: "66.8,29.5 66.8,20.5 75.5,20.5  75.5,22.3 68.9,22.3 68.9,24.1 74.6,24.1 74.6,25.9 68.9,25.9 68.9,27.7 75.5,27.7 75.5,29.5 66.8,29.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7_00000124158393893560559510000010822914887849982124_",
    className: "st0",
    d: "M79.3,24.6h4.6v-2.4h-4.6V24.6z M77.2,29.5 v-9.1h7.3c1,0,1.5,0.6,1.5,1.5V25c0,0.7-0.6,1.3-1.8,1.3c-0.1,0-0.1,0-0.2,0l2.1,3.2h-2.3l-2-3.1h-2.4v3.1H77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8_00000049928801973069631170000007424392639962483840_",
    className: "st0",
    d: "M89.8,29.5h-0.7c-0.9,0-1.4-0.5-1.4-1.3V27 h2.1v0.7h4.5v-1.9c0,0-4.3,0-5.1,0c-0.8,0-1.4-0.6-1.4-1.3v-2.7c0-0.8,0.6-1.4,1.4-1.4s5.9,0,5.9,0c0.8,0,1.3,0.6,1.3,1.4 c0,0.9,0,1.1,0,1.1h-2.1v-0.7h-4.5V24h5.1c0.8,0,1.4,0.5,1.4,1.5v2.6c0,0.9-0.5,1.4-1.4,1.4C94.1,29.5,89.8,29.5,89.8,29.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9_00000018921283837283842710000005369560766706271372_",
    className: "st0",
    points: "98.4,29.5 98.4,20.5 100.6,20.5  100.6,24.1 104.7,20.5 107.6,20.5 102.7,24.7 107.7,29.5 104.7,29.5 100.6,25.4 100.6,29.5 98.4,29.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,14.7H17.4c-1.3,0-2.4,1.1-2.4,2.4V33c0,1.3,1.1,2.4,2.4,2.4h14.8c1.3,0,2.3-1.1,2.3-2.4V17 C34.5,15.7,33.5,14.7,32.2,14.7z M33.4,27.2h-6.2l1.4,6l0,0l-3.9-4.8l-3.9,4.8l0,0l1.4-6H16l0,0l5.6-2.7l-3.9-4.8l0,0l5.6,2.7 l1.4-6l0,0l1.4,6l5.6-2.7l0,0l-3.9,4.8L33.4,27.2L33.4,27.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaersk);
export default __webpack_public_path__ + "static/media/maersk.9faec325220bffe296ada05ceabcd052.svg";
export { ForwardRef as ReactComponent };